module.exports = __webpack_public_path__ + "static/media/no-floorplans.add51784.svg";